import { useState, useEffect, useRef } from "react";
import { v4 as uuidv4 } from "uuid";

import { API_URL_DONATE } from "../../utils/helpers";

import Alert from "../../components/Alert";
import Msg from "../../components/Msg";

import PaymentCloverForm from "./PaymentCloverForm";

export default function PaymentClover({ cares, id, status }) {
	const [order, setOrder] = useState({});
	const [msg, setMsg] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const initRef = useRef(false);

	useEffect(() => {
		if (initRef.current) return;
		initRef.current = true;
		//window.scrollTo(0, 0);
		init();
	});

	const init = async () => {
		const url = new URL(`${API_URL_DONATE}/`);
		const params = {
			f: "paymentInit",
			id,
			x: uuidv4(),
		};
		url.search = new URLSearchParams(params);

		try {
			const response = await fetch(url, {
				method: "GET",
				cache: "no-store",
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setOrder({
					items: json.items,
					totals: json.totals,
					text: json.text,
				});
				setAlert({});
			} else {
				setAlert({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setAlert({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	const handleToken = async (token) => {
		console.log("Received Clover token:", token);

		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL_DONATE}/?f=payment`);
		const formData = new FormData();
		formData.append("id", id || "0");
		formData.append("token", token || "");
		formData.append("x", uuidv4());

		try {
			const response = await fetch(url.href, {
				method: "POST",
				body: formData,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setMsg({});
				status(id, 1);
			} else {
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div className="receipt">
						<h3>Payment</h3>

						<p>{order.text}</p>

						<table className="order">
							<thead>
								<tr>
									<th>Qty</th>
									<th className="left">Item</th>
									<th>Amount</th>
								</tr>
							</thead>
							<tbody>
								{order.items.map((item, index) => {
									return (
										<tr key={index}>
											<td className="center">
												<span>{item.qty}</span>
											</td>
											<td>
												<div>
													<span>{item.item}</span>
													<small>{item.subitem}</small>
												</div>
											</td>
											<td className="right">{item.price}</td>
										</tr>
									);
								})}
							</tbody>
							<tfoot>
								<tr>
									<td colSpan="2" className="right">
										TOTAL
									</td>
									<td className="right">{order.totals.total}</td>
								</tr>
							</tfoot>
						</table>
					</div>

					<div className="msg-submit">
						{msg.type && <Msg data={msg} />}

						<div
							className={
								msg.type === "working" ? "hidden" : "clover-form-container"
							}
						>
							<PaymentCloverForm handleToken={handleToken} />
						</div>
					</div>
				</>
			)}
		</>
	);
}
